import { signal } from "@angular/core";
import { AppConfig } from "../models/app-config.model";
import { toObservable } from "@angular/core/rxjs-interop";
import { Environment } from "../models/environment.model";
import _appConfig from "../../../konfig/app.config.json";
import { TestService } from "./test.service";

export class AppConfigService {
  private readonly _appConfig = signal<AppConfig>(undefined);
  public readonly appConfig = this._appConfig.asReadonly();
  public readonly appConfig$ = toObservable(this._appConfig);

  constructor(appConfig?: AppConfig) {
    this._appConfig.set(appConfig);
  }

  public static async fetchAppConfig(environment: Environment): Promise<AppConfig> {
    if (!environment.production && !TestService.isRunningInTestContext) {
      return _appConfig as AppConfig;
    }

    try {
      return await (await fetch(environment.appConfig)).json();
    } catch (error) {
      throw new Error(`Kunne ikke laste app config fra: ${environment.appConfig}`, { cause: error });
    }
  }
}
